var module = 'hospitalBooking', name = 'hospital-booking/config/locales/en.json', content = {
  "hospital_booking": {
    "action_feedback": {
      "confirm": "Thank you for having confirmed your presence.",
      "confirm_subtitle": "",
      "cancel": "The cancellation request has been sent.",
      "cancel_subtitle": "",
      "call_back": "We received your request.",
      "call_back_subtitle": "You will receive a call from the clinic shortly.",
      "transfer": "We have received your request to reschedule the appointment",
      "transfer_subtitle": "You will receive a call from the clinic shortly to move your appointment.",
      "unavailable": "The selected option is no longer available.",
      "unavailable_subtitle": "Please contact the clinic for more information."
    },
    "confirm_action": {
      "confirm": "Are you sure you want to confirm this appointment?",
      "cancel": "Are you sure you want to cancel this appointment?",
      "call_back": "Are you sure you want to ask to be reached regarding this appointment?",
      "transfer": "Are you sure you want to ask to move this appointment?"
    },
    "execute_action": {
      "title": "Choose one of the following actions",
      "cancel": "Request to cancel appointment",
      "confirm": "Confirm my attendance",
      "call_back": "Request to be called back",
      "transfer": "Reschedule appointment"
    }
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./hospital-booking/config/locales/en.json
// module id = 777
// module chunks = 0